import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from "primevue/button";


interface Props {
  text?: string;
  secondary?: boolean;
  class?: string;
  ariaLabel?: string;
  yellow?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'agilaButton',
  props: {
    text: { default: "" },
    secondary: { type: Boolean, default: false },
    class: { default: "" },
    ariaLabel: { default: "" },
    yellow: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    class: _normalizeClass({
      [props.class]: true,
      'p-button-sec': props.secondary,
      'p-button-yellow': props.yellow,
    }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    "aria-label": props.ariaLabel,
    tabindex: 0,
    severity: props.secondary ? 'secondary' : 'primary'
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.text) + " ", 1),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "aria-label", "severity"]))
}
}

})